var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.error)?_c('img',{staticClass:"img",attrs:{"src":_vm.assetSrc,"alt":_vm.item.title},on:{"load":_vm.onImageLoad,"error":_vm.onImageError}}):_c('span',{staticClass:"img error",attrs:{"data-src":_vm.item.src}},[_vm._v(" "+_vm._s(_vm.errorStatus)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }